export default __webpack_public_path__ + "static/media/LAS0810.34I-38023_-26221_0.39959244.jpg";